var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-ag-grid',{attrs:{"title":"Products","columnDefs":_vm.columnDefs,"rowData":_vm.products,"loading":_vm.loading,"mobileCard":_vm.mobileCard},on:{"refresh":_vm.fetchProducts,"add":_vm.onAdd,"row-dbl-click":(data) => _vm.$router.push({ path: `products/${data._id}/edit` })}})
}
var staticRenderFns = []

export { render, staticRenderFns }